export default __webpack_public_path__ + "static/media/BlackCurtain5.c4277314.png";